import {normalizePeriod} from '../../../../utils/formatter'

export const makeFlightDepartureInfo = function (state, payload) {
  // normalizza il periodo
  payload.arrivalPeriod = normalizePeriod(payload.arrivalPeriod)
  // imposta come data per usufruire del servizio il giorno del volo
  return payload
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/flightDepartureInfo.js